// Rule selections for packing
export const PACKING_RULES_SELECTION = {
    UNPACKED: {
        label: 'Pack All Unpacked Products When Condition Is Met',
        value: 'unpacked',
    },
    MATCHED: {
        label: 'Pack Products That Match Condition',
        value: 'matched',
    },
};

export const INDIVIDUAL_PACKING = 'individual-packing';
export const WEIGHT_PACKING = 'weight-packing';
export const DIMENSIONAL_PACKING = 'dimensional-packing';
export const QUANTITY_PACKING = 'quantity-packing';
export const ADD_TO_EXISTING_PALLET_SKID = 'add-to-existing-pallet-skid';
export const PALLETISE_BY_CUBIC = 'palletise-by-cubic';
export const SKIP_ITEM_PACKING = 'skip-item-packing';


export const PACKING_METHODS = [
    { text: 'Individual Packing', value: INDIVIDUAL_PACKING, 'description': 'Each item is packaged in its own separate container or packaging' },
    { text: 'Weight Packing', value: WEIGHT_PACKING, 'description': 'Items are grouped into packages such that the total weight of each package is close to (but does not exceed) a predetermined weight limit.' },
    { text: 'Dimensional Packing', value: DIMENSIONAL_PACKING, 'description': 'Items are grouped to maximize the use of available space in a package or container without exceeding its cubic capacity' },
    { text: 'Quantity Packing', value: QUANTITY_PACKING, 'description': 'Pack items based on quantity' },
    { text: 'Add to Existing Pallet, Skid or Crate', value: ADD_TO_EXISTING_PALLET_SKID, 'description': 'Add items to an existing Pallet, Skid or Crate' },
    { text: 'Palletise By Cubic', value: PALLETISE_BY_CUBIC, 'description': 'Determines how many pallets are needed based on the total cubic volume of all items relative to one pallet\'s cubic capacity' },
    { text: 'Do not pack (Ignore)', value: SKIP_ITEM_PACKING, 'description': 'Exclude items from the final packages' },
];

export const PACKING_METHODS_WITH_BOXES = [
    WEIGHT_PACKING,
    DIMENSIONAL_PACKING,
    QUANTITY_PACKING,
    PALLETISE_BY_CUBIC,
];

export const ITEM_PACKING_LOG_META_KEY = 'ITEM_PACKING_LOG';